import React from 'react';
import {Carousel, Container, Card, Row, Col}  from 'react-bootstrap';

function HomePage() {
    
    return (
      <Container><Row><Col xs={12} sm={12} md={6} lg={6}>
      <Carousel wrap={true} fade={true} interval={5000} controls={true} indicators={true} indicatorLabels={["One", "Two","Three"]}>
      <Carousel.Item>
        <Card>
        <Card.Img variant="top" src="/images/splash1.jpg" alt="First slide"></Card.Img>
        <Card.Header className="card-goal-header">Card 1</Card.Header>
        <Card.Body>
        This is the card body
        </Card.Body>
        </Card>
      </Carousel.Item>

      <Carousel.Item>
        <Card>
        <Card.Img variant="top" src="/images/splash2.jpg" alt="First slide"></Card.Img>
        <Card.Header className="card-goal-header">Card 2</Card.Header>
        <Card.Body>
        This is the card body
        </Card.Body>
        </Card>
      </Carousel.Item>

      <Carousel.Item>
        <Card>
        <Card.Img variant="top" src="/images/splash3.jpg" alt="First slide"></Card.Img>
        <Card.Header className="card-goal-header">Card 3</Card.Header>
        <Card.Body>
        </Card.Body>
        This is the card body
        </Card>
      </Carousel.Item>
      <Carousel.Item>
        <Card>
        <Card.Img variant="top" src="/images/splash4.jpg" alt="First slide"></Card.Img>
        <Card.Header className="card-goal-header">Card 4</Card.Header>
        <Card.Body>
        </Card.Body>
        This is the card body
        </Card>
      </Carousel.Item>
    </Carousel>
    </Col></Row></Container>
  );
}

export default HomePage;
